import axios from 'axios';
import * as _ from 'lodash';
import { transformDataWithSubgroups } from '../services/transformDataService';

export default {
	state: () => ({
		contentSearchPhrase: '',
		contentQueryString: {},
		contentTab: null,
		contentInitialTab: {},
		contentSearchFacets: [],
		contentFacetGroups: [],
		eventCalendarTabs: [],
		activeSidebarFiltersType: '',
		contentOriginalResults: [],
		contentPaginatedResults: [],
		contentPageNumber: 1,
		contentSearchItemsPerPage: null,
		contentExpectedResultsNumberOnPage: null,
		constantSearchParams: {},
		activeLibraryFilters: {},
		activeFiltersAsSearchParam: '',
		activeSubgroups: [],
		isFiltersDisabled: false,
		isFirstPageLoaded: false,
		isEventCalendarLibrary: false,
		isPastEventDisplayed: false,
		totalResultsCount: null,
		contentLibraryComposable: {},
		pagination: {}
	}),
	getters: {
		getActiveSidebarFiltersType: (state) => {
			return state.activeSidebarFiltersType;
		},
		getActiveLibraryFilters: (state) => {
			return state.activeLibraryFilters;
		},
		getActiveFiltersAsSearchParam: (state) => {
			return state.activeFiltersAsSearchParam;
		},
		getContentSearchPhrase: (state) => {
			return state.contentSearchPhrase;
		},
		getContentQueryString: (state) => {
			return state.contentQueryString;
		},
		getContentSearchFacets: (state) => {
			return state.contentSearchFacets;
		},
		getContentFacetGroups: (state) => {
			return state.contentFacetGroups;
		},
		getActiveSubgroups: (state) => {
			return state.activeSubgroups;
		},
		getSortedContentSearchFacets(state) {
			return state.contentSearchFacets.concat().sort((a, b) => a.ranking - b.ranking);
		},
		getContentTab: (state) => {
			return state.contentTab;
		},
		getContentInitialTab(state) {
			return state.contentInitialTab;
		},
		getEventCalendarTabs: (state) => {
			return state.eventCalendarTabs;
		},
		getContentPaginatedResults: (state) => {
			return state.contentPaginatedResults;
		},
		getContentPageNumber: (state) => {
			return state.contentPageNumber;
		},
		getContentItemsPerPage: (state) => {
			return state.contentSearchItemsPerPage;
		},
		getContentExpectedResultsNumberOnPage: (state) => {
			return state.contentExpectedResultsNumberOnPage;
		},
		getConstantSearchParams: (state) => {
			return state.constantSearchParams;
		},
		getIsFiltersDisabled: (state) => {
			return state.isFiltersDisabled;
		},
		getIsFirstPageLoaded: (state) => {
			return state.isFirstPageLoaded;
		},
		getIsPastEventDisplayed: (state) => {
			return state.isPastEventDisplayed;
		},
		getTotalResultsCount: (state) => {
			return state.totalResultsCount;
		},
		getContentLibraryComposable: (state) => {
			return state.contentLibraryComposable;
		},
		getLibraryPagination: (state) => {
			return state.pagination;
		},
	},
	mutations: {
		setContentSearchPhrase: (state, phrase) => {
			state.contentSearchPhrase = phrase;
		},
		setContentQueryString: (state, query) => {
			state.contentQueryString = { ...query };
		},
		setContentTab: (state, tab) => {
			state.contentTab = { ...tab };
		},
		setContentInitialTab: (state, facets) => {
			if (!state.isEventCalendarLibrary) {
				state.contentInitialTab = facets.find((x) => x.term === 'All');
			} else {
				state.contentInitialTab = state.eventCalendarTabs[0];
			}
		},
		setContentFacets: (state, facets) => {
			state.contentSearchFacets = facets;
		},
		setEventCalendarTabs: (state, tabs) => {
			state.eventCalendarTabs = tabs;
		},
		setActiveSidebarFiltersType: (state, filtersType) => {
			if (state.activeSidebarFiltersType != filtersType) {
				state.activeSidebarFiltersType = filtersType;
			}
		},
		setActiveSubgroups: (state, subgroupName) => {
			if (state.activeSubgroups.indexOf(subgroupName) !== -1) {
				state.activeSubgroups.splice(state.activeSubgroups.indexOf(subgroupName), 1);
			} else {
				state.activeSubgroups.push(subgroupName);
			}
		},
		setIsEventCalendarLibrary: (state) => {
			state.isEventCalendarLibrary = true;
		},
		setContentPaginatedResults: (state, results) => {
			if (state.isEventCalendarLibrary) {
				state.contentOriginalResults = results;
				state.contentPaginatedResults = transformDataWithSubgroups(results);
			} else {
				state.contentPaginatedResults = results;
			}
		},
		addToContentPaginatedResults: (state, results) => {
			if (state.isEventCalendarLibrary) {
				state.contentOriginalResults = state.contentOriginalResults.concat(results);
				state.contentPaginatedResults = transformDataWithSubgroups(results, state.contentOriginalResults);
			} else {
				state.contentPaginatedResults = state.contentPaginatedResults.concat(results);
			}
		},
		setContentPageNumber: (state, pageNumber) => {
			if (pageNumber) {
				state.contentPageNumber = pageNumber;
			} else {
				state.contentPageNumber++;
			}
			state.constantSearchParams.pn = state.contentPageNumber;
		},
		setContentItemsPerPage: (state, searchItemsPerPage) => {
			state.contentSearchItemsPerPage = searchItemsPerPage;
		},
		setContentExpectedResultsNumberOnPage: (state, pageItems) => {
			state.contentExpectedResultsNumberOnPage = pageItems;
		},
		setConstantSearchParams: (state, searchParamsObj) => {
			state.constantSearchParams = searchParamsObj;
		},
		setActiveFiltersAsSearchParam(state) {
			let searchFilterParams = '',
				separator = '';
			if (!_.isEmpty(state.activeLibraryFilters)) {
				_.forEach(state.activeLibraryFilters, (value, key) => {
					separator = searchFilterParams === '' ? '' : ';';
					searchFilterParams += separator + key + ':' + Object.values(value).join(',')
				});
			}
			state.activeFiltersAsSearchParam = searchFilterParams;
		},
		setActiveFiltersCategories: (state, payload) => {
			if (payload.items) {
				state.activeLibraryFilters[payload.group] = payload.items;
			}
			else {
				delete state.activeLibraryFilters[payload.group]
			}
		},
		resetContentPageNumber: (state) => {
			state.contentPageNumber = 1;
			state.constantSearchParams.pn = 1;
		},
		updateUrlSearchParams(state) {
			if (window.history.pushState) {
				window.history.replaceState(null, null, window.location.pathname);
				const url = new URL(window.location.href);
				_.forEach(state.contentQueryString, function (value, key) {
					url.searchParams.set(key, value);
				});
				window.history.pushState({}, '', url.toString());
			}
		},
		setIsFiltersDisabled: (state, status) => {
			state.isFiltersDisabled = status;
		},
		setIsFirstPageLoaded: (state, payload) => {
			state.isFirstPageLoaded = payload;
		},
		setContentFacetGroups: (state, facetGroups) => {
			let facetsWithSubgroups = facetGroups.filter((element) => element.data.some((subElement) => subElement.subGroupName !== null));
			if (facetsWithSubgroups.length) {
				facetsWithSubgroups.forEach(group => {
					let
						subgroups = [...new Set(group.data.map(subgroup => subgroup.subGroupName))],
						items = [],
						dataArray = [];
					state.activeSubgroups = subgroups.concat().sort((a, b) => b - a);
					subgroups.forEach(subgroup => {
						items = group.data.filter(element => element.subGroupName === subgroup);
						dataArray.push({ subGroupName: subgroup, visible: items.filter(item => item.visible).length ? true : false, items: items })
					});
					group.data = dataArray;
				});
			}
			state.contentFacetGroups = [...facetGroups];
		},
		setIsPastEventDisplayed(state, status) {
			state.isPastEventDisplayed = status;
		},
		setTotalResultsCount(state, count) {
			state.totalResultsCount = count;
		},
		setContentLibraryComposable: (state, contentLibraryComposable) => {
			state.contentLibraryComposable = contentLibraryComposable;
		},

		setPagination: (state, pagination) => {
			state.pagination = pagination
		}
	},
	actions: {
		setActiveLibraryFilters: ({ commit, state }) => {
			if (!state.contentFacetGroups || !state.contentFacetGroups.length) {
				return;
			}
			else {
				let arrayForItems;
				state.contentFacetGroups.forEach((group) => {
					arrayForItems = [];
					group.data.forEach((facet) => {
						if (facet.items) {
							facet.items.forEach((item) => {
								if (item.checked) {
									arrayForItems.push(item.name);
								}
							});
						}
						else if (facet.checked) {
							arrayForItems.push(facet.name);
						}
					});
					if (arrayForItems.length) {
						commit('setActiveFiltersCategories', { group: group.id, items: arrayForItems });
					}
				});
			}
		},
		resetContentFacetGroups: ({ dispatch, state }) => {
			state.contentFacetGroups.forEach((group) => {
				group.data.forEach((facet) => {
					if (!facet.items) {
						facet.checked = false;
					}
					else {
						facet.items.forEach((item) => {
							item.checked = false;
						});
					}
				});
			});
			state.activeLibraryFilters = {};
			return dispatch('executeSearchWithFilters');
		},
		resetGroup({ commit }, group) {
			group.data.forEach((facet) => {
				if (!facet.items) {
					facet.checked = false;
				}
				else {
					facet.items.forEach((item) => {
						item.checked = false;
					});
				}
			});
			commit('setActiveFiltersCategories', { group: group.id });
		},
		resetCurrentFacetGroups: ({ dispatch, state }) => {
			state.contentFacetGroups.forEach((group) => {
				const monthFilterGroup = group.data[0].subGroupName != null;
				if (state.activeSidebarFiltersType === 'month') {
					if (monthFilterGroup) {
						dispatch('resetGroup', group);
					}
				}
				else if (!monthFilterGroup) {
					dispatch('resetGroup', group);
				}
			});
			return dispatch('executeSearchWithFilters');
		},
		executeSearchWithFilters({ dispatch, commit, state }) {
			commit('setContentExpectedResultsNumberOnPage', state.contentSearchItemsPerPage);
			commit('resetContentPageNumber');
			return dispatch('fetchContentResults', { fc: !state.isEventCalendarLibrary ? state.contentQueryString.fc : '' });
		},
		fetchContentResults: ({ dispatch, commit, state }, searchParamsObj) => {
			commit('setIsFiltersDisabled', true);
			commit('setActiveFiltersAsSearchParam');
			let params = {};
			//if page was loaded without search params
			if (!searchParamsObj.searchParams) {
				params = {
					q: state.contentSearchPhrase,
					fc: searchParamsObj.fc ? searchParamsObj.fc : '',
					fgs: state.activeFiltersAsSearchParam,
					DisplayPastEvents: state.isPastEventDisplayed,
				};
				commit('setContentQueryString', _.pickBy(params, (value, key) => { return value !== undefined && value != '' }));
				commit('updateUrlSearchParams');
			}
			else {
				params = { ...state.contentQueryString};
			}
			params = { ...params, ...state.constantSearchParams};
			if (searchParamsObj.clearParameters) {
				return dispatch('resetContentFacetGroups');
			}
			commit('setSpinnerIsShown', true, { root: true });
			return axios
				.get('/api/globalsearch/content', { params: params })
				.then((response) => {
					commit('setSpinnerIsShown', false, { root: true });
					if (response.data) {
						if (params.pn === 1) {
							commit('setIsFirstPageLoaded', true);
						}
						commit('setTotalResultsCount', response.data.totalResults);
						commit('setContentInitialTab', response.data.facets);
						commit('setContentFacets', response.data.facets);
						commit('setContentFacetGroups', response.data.facetGroups);

						commit('setPagination', response.data.paginationItems);

						if (state.contentExpectedResultsNumberOnPage > state.contentSearchItemsPerPage) {
							commit('addToContentPaginatedResults', response.data.items);
						} else {
							commit('setContentPaginatedResults', response.data.items);
						}
						dispatch('setActiveLibraryFilters');
						if (response.data.items.length && !state.isEventCalendarLibrary) {
							if (params.fc) {
								commit('setContentTab', response.data.facets.find(x => x.term === params.fc));
							}
							else {
								commit('setContentTab', state.contentInitialTab);
							}
						} else {
							if (params.DisplayPastEvents) {
								commit('setContentTab', state.eventCalendarTabs[1]);
							} else {
								commit('setContentTab', state.eventCalendarTabs[0]);
							}
						}
					}
				})
				.catch((error) => {
					console.warn(error);
					commit('setSpinnerIsShown', false, { root: true });
				})
				.finally(() => {
					commit('setIsFiltersDisabled', false);
				});
		},

		paginationLibraryClickHandler: ({ dispatch, commit }, page) => {
            commit('setContentPageNumber', page);
		}
	},
};
